import { CanActivateFn } from '@angular/router';

export const permissionGuard: CanActivateFn = (_route, _state) => {
  // Add permission check logic here as needed for routes
  return true;
};

